import { QuotesDataViewContext } from "@MasterBluePrint/Store/Data/Quote/QuoteSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface QuoteSearchResultCountStyles {
    quoteCountText?: TypographyPresentationProps;
}

export const resultCountStyles: QuoteSearchResultCountStyles = {
    quoteCountText: {
        css: css`
            color: #002554;
            font-family: 'Roboto', sans-serif;
            font-size: 20px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 22px;
            white-space: nowrap;
        `,
    }
};

const styles = resultCountStyles;

const QuoteSearchResultCount: FC<WidgetProps> = () => {
    const quoteDataView = useContext(QuotesDataViewContext);

    if (!quoteDataView.value || !quoteDataView.pagination) {
        return null;
    }

    const { totalItemCount } = quoteDataView.pagination;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <Typography {...styles.quoteCountText} data-test-selector="quoteSearch_resultCount">
            {totalItemCount} {translate("Quotes")}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: QuoteSearchResultCount,
    definition: {
        group: "RFQ My Quotes",
        displayName: "Result Count",
    },
};

export default widgetModule;
